import React, { Component, Fragment } from 'react';
import { Button, FormValidationMessage, Input, Form, SimpleMarkdown } from '../../atoms';
import { REGEX, LANDING_EMAIL } from '../../../constants/index';
import { contactRequest } from '../../../services/taggisApi';
import { genClassName } from '../../../utils//helpers';

import './styles.css';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {String} buttonLabel
 * @prop {String} emailLabel
 * @prop {String} firstNameLabel
 * @prop {String} lastNameLabel
 * @prop {String} messageLabel
 * @prop {String} organizationLabel
 * @prop {String} organizationRoleLabel
 * @prop {String} termsContent
 * @prop {Function} onSuccess
 * @prop {String} [className]
 * @prop {String} [buttonVariant]
 *
 * @augments {Component<Props>}
 */
export default class ContactForm extends Component {

	// Incrementing `formKey` forces a re-render of the form on a successful submission, clearing current values.
	state = {
		formKey: 0,
	}

	handleSuccess = () => {
		this.setState(({ formKey }) => ({
			formKey: ++formKey,
		}));
	};

	renderForm = ({
		buttonLabel,
		emailLabel,
		firstNameLabel,
		lastNameLabel,
		messageLabel,
		// organizationLabel,
		// organizationRoleLabel,
		termsContent,
		validationMessage,
		buttonVariant,
	}, state) => (
		<Fragment>
			{state.errors.length
				? <FormValidationMessage
					errors={state.errors}
					validationMessage={validationMessage}
				/>
				: null
			}
			<div className='ContactForm-split'>
				<Input
					autoComplete='given-name'
					label={firstNameLabel}
					name='first_name'
					pattern={REGEX.name}
					required
					type='text'
					animated={true}
				/>
				<Input
					autoComplete='family-name'
					label={lastNameLabel}
					name='last_name'
					pattern={REGEX.name}
					required
					type='text'
					animated={true}
				/>
			</div>
			<Input
				autoComplete='email'
				label={emailLabel}
				name='email'
				required
				type='email'
				animated={true}
			/>
			<Input
				label={messageLabel}
				name='message'
				required
				rows={5}
				type='textarea'
				animated={true}
			/>
			<SimpleMarkdown>{termsContent}</SimpleMarkdown>
			<input hidden={true} readOnly name='landing_email' value={LANDING_EMAIL} />
			<Button variant={buttonVariant} className='ContactForm-button' type='submit' submitting={state.isSubmitting}>{buttonLabel}</Button>
		</Fragment>
	);

	render () {
		return (
			<div className={genClassName('ContactForm', this.props.className)}>
				<Form key={this.state.formKey}
					{...this.props}
					submitHandler={contactRequest}
					onSuccess={() => {
						this.handleSuccess();
						this.props.onSuccess();
					}}
					render={(state) => this.renderForm(this.props, state)}
				/>
			</div>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/molecules/ContactForm/ContactForm.js